// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"1f0df10e","488":"ff73de86","755":"3af5cb18"}[chunkId] + ".chunk.js";
};